import React from 'react';
import SvgIcon, { IconProps, getColor } from './SvgIcon';

export default function QuoteIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fill="none"
        stroke={getColor(props.color)}
        d="M10 8c0 1.9 0 2.8-.6 3.4-.6.6-1.5.6-3.4.6s-2.8 0-3.4-.6C2 10.8 2 10 2 8s0-2.8.6-3.4C3.2 4 4 4 6 4s2.8 0 3.4.6c.6.6.6 1.5.6 3.4Z"
      />
      <path fill="none" stroke={getColor(props.color)} d="M10 7v4.5A9 9 0 0 1 4 20" />
      <path
        fill="none"
        stroke={getColor(props.color)}
        d="M22 8c0 1.9 0 2.8-.6 3.4-.6.6-1.5.6-3.4.6s-2.8 0-3.4-.6C14 10.8 14 10 14 8s0-2.8.6-3.4C15.2 4 16 4 18 4s2.8 0 3.4.6c.6.6.6 1.5.6 3.4Z"
      />
      <path fill="none" stroke={getColor(props.color)} d="M22 7v4.5a9 9 0 0 1-6 8.5" />
    </SvgIcon>
  );
}
